import { Helmet } from "react-helmet-async";

export const Seo = ({ title, description, path = "/" }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <link rel="canonical" href={`https://honest-hearth.emergent.host${path}`} />
    <meta property="og:url" content={`https://honest-hearth.emergent.host${path}`} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content="https://honest-hearth.emergent.host/og-image.jpg" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content="https://honest-hearth.emergent.host/og-image.jpg" />
  </Helmet>
);
